<template>
  <div class="user-mgmt-view-contract">
    <div class="main-title">
      <p @click="back">组织管理</p>>查看合同
    </div>
    <div class="main-body">
      <table class="table-custom">
        <thead>
        <tr>
          <th>外部合同号</th>
          <th>合同编号</th>
          <th>通道类型</th>
          <th>合同类型</th>
          <th>状态</th>
          <th>创建时间</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length > 0">
        <tr v-for="item in dataList" :key="item.number">
          <td>{{ item.id }}</td>
          <td>{{ item.contractNo }}</td>
          <td>{{ item.channelType }}</td>
          <td>{{ item.type }}</td>
          <td>{{ item.status }}</td>
          <td>{{ item.createTime }}</td>
          <td>
            <a v-if="item.channelTypeCode == 1" class="text-btn"
               :href="'/sign/bestSignDownloadContract?contractId=' + item.id">下载合同</a>
            <a v-if="item.channelTypeCode == 1" class="text-btn"
               :href="'/sign/bestSignDownloadAttachment?contractId=' + item.id">下载存证</a>
            <a v-if="item.channelTypeCode == 2 && item.penetrateSignNo && item.status == '已生效' && domainType != '2'"
               class="text-btn"
               :href="'/bankDirectCredit/contract/'+item.penetrateSignNo+'/TP_BLOCKCHAIN_AM_002/'+item.penetrateSignNo+'_TP_BLOCKCHAIN_AM_002.pdf'">下载</a>
            <a v-if="item.channelTypeCode == 2 && item.penetrateSignNo && item.status == '已生效' && domainType == '2'"
               class="text-btn"
               :href="'/bankDirectCredit/contract/'+item.penetrateSignNo+'/TP_BLOCKCHAIN_HAILI_001/'+item.penetrateSignNo+'_TP_BLOCKCHAIN_HAILI_001.pdf'">下载</a>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="6">暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="page-count">第{{ pageIndex }}页，当前页{{ dataList.length }}条</div>
        <div class="page-count">
          跳转到第
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          页
        </div>
        <div class="page-count text-btn" @click="onPageChooseBtnClick">跳转</div>
        <div
          class="pre-btn"
          disabled
          :class="preBtnDisabled?'disabled':''"
          @click="onPreBtnClick"
        >上一页
        </div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "../../utils/utils";

export default {
  name: "userMgmtContractView",
  data() {
    return {
      userAccountNo: "",
      unitMemberNo: "",
      page: '',
      dataList: [],
      beginIndex: 0,
      pageSize: 10,
      total: 0,
      totalPage: 0,
      preBtnDisabled: true,
      nextBtnDisabled: true,
      domainType: ''
    };
  },
  computed: {
    pageIndex() {
      return Math.floor(this.beginIndex / this.pageSize) + 1;
    }
  },
  mounted() {
    this.userAccountNo = this.$attrs.userAccountNo;
    this.unitMemberNo = this.$attrs.unitMemberNo;
    this.queryUserContractSignRecord();
    let domain = Utils.getDomain();
    if (domain == 'iot.lititi.com' || domain == 'hailixinnengyuan.com' || domain == 'leasehold-test.lititi.com' || domain == 'leasehold-dev.lititi.com') {
      this.domainType = '2';
    }
  },
  methods: {
    queryUserContractSignRecord() {
      let params = {
        userAccountNo: this.userAccountNo,
        unitMemberNo: this.unitMemberNo
      };
      this.$http
        .post(
          "/managementPlatform/admin/queryUserContractSignRecord",
          this.$qs.stringify(params)
        )
        .then(response => {
          let res = response.data;
          if (!res || !res.result) {
            this.$message({
              type: "error",
              message: res.message || "查询失败!",
              center: true
            });
            return;
          }
          this.dataList = res.ldata;
        })
        .catch(err => {
          console.log(err);
        });
    },
    onQueryBtnClick() {
      this.queryUserContractSignRecord();
    },

    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.queryUserAccount();
    },

    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.queryUserAccount();
    },

    onPageChooseBtnClick() {
      let index = 0;
      if (this.page <= this.totalPage && this.page > 0) {
        index = this.page;
      } else {
        index = 1;
        this.page = 1;
      }
      this.beginIndex = (index - 1) * this.pageSize;
      this.queryUserContractSignRecord();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && this.preBtnDisabled;
      this.beginIndex > 0 && !this.preBtnDisabled;
      length > this.pageSize && !this.nextBtnDisabled;
      length <= this.pageSize && this.nextBtnDisabled;
    },
    back() {
      this.$parent.back()
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;

  .name-label {
    float: left;
  }

  .value-label {
    display: inline-block;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #bee6b3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }
}

.page-choose.fixed-width-35 {
  width: 35px;
}
</style>
<style>
.page-choose input.el-input__inner {
  padding: 0 5px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/unitMgmt/userMgmtContractView.vue